import { MemberPortalSearchTypeItem } from "./MemberPortalSearchTypeItem"

export class MemberPortalSearchType {
    public static MyDraftSearch: MemberPortalSearchTypeItem = { value: 0, code: "MY_DRAFT_SEARCH" }
    public static MyRegisteredSearch: MemberPortalSearchTypeItem = { value: 1, code: "MY_REGISTERED_SEARCH" }
    public static AllRegisteredSearch: MemberPortalSearchTypeItem = { value: 2, code: "ALL_REGISTERED_SEARCH" }
}